export const TONES = {
  blue: "#3B82F6", green: "#10B981", amber: "#F59E0B", red: "#EF4444", violet: "#8B5CF6", teal: "#14B8A6", orange: "#F97316", pink: "#EC4899",
};

export const THEMES = [
  {
    id: "tactical",
    name: "الأسطول الأطلسي",
    tagline: "كحلي داكن مع ذهبي كهرماني — فخامة وقوة تليق بشركة نقل ثقيل",
    fonts: { head: "Cairo", body: "Tajawal", url: "https://fonts.googleapis.com/css2?family=Cairo:wght@600;700;900&family=Tajawal:wght@400;500;700&display=swap" },
    swatch: ["#0B132B", "#151E3D", "#F59E0B", "#1E6091"],
    dark: true,
    page: "bg-[#0B132B] text-slate-100",
    sidebar: "bg-[#070D1E] border-l border-white/10",
    navItem: "text-slate-300 hover:bg-white/5",
    navActive: "bg-amber-500/15 text-amber-300 border border-amber-500/30",
    header: "bg-[#0E1733] border-b border-white/10",
    card: "bg-[#151E3D] border border-white/10 rounded-2xl shadow-xl hover:border-amber-500/40",
    muted: "text-slate-400",
    btn: "bg-gradient-to-l from-amber-400 to-amber-600 text-slate-950 font-black rounded-xl shadow-lg shadow-amber-500/20",
    btnGhost: "bg-white/5 border border-white/10 text-slate-100 rounded-xl",
    badgeAdm: "bg-amber-500 text-slate-950", badgePlate: "border border-amber-500/40 text-amber-200",
    logo: "bg-gradient-to-br from-amber-400 to-amber-600 text-slate-950",
    tableHead: "bg-white/5 text-slate-300", row: "border-white/5",
    driverHero: "bg-gradient-to-bl from-[#1C2541] to-[#0B132B] border-b-4 border-amber-500",
    tile: "bg-[#151E3D] border border-white/10 border-r-4 border-r-amber-500 rounded-2xl",
    icon: (c) => ({ background: `${c}26`, color: c, border: `1px solid ${c}55`, boxShadow: `0 0 18px ${c}33`, borderRadius: 16 }),
    pill: (c) => ({ background: `${c}22`, color: c }),
  },
  {
    id: "emerald",
    name: "الخليج العصري",
    tagline: "فاتح ومريح بالأخضر الزمردي ولمسات رملية — واضح جداً تحت الشمس",
    fonts: { head: "IBM Plex Sans Arabic", body: "Readex Pro", url: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Arabic:wght@500;600;700&family=Readex+Pro:wght@300;400;500;600&display=swap" },
    swatch: ["#F7F5F0", "#FFFFFF", "#059669", "#D97706"],
    dark: false,
    page: "bg-[#F7F5F0] text-slate-900",
    sidebar: "bg-[#064E3B] border-l border-emerald-900",
    navItem: "text-emerald-100/80 hover:bg-white/10",
    navActive: "bg-white text-emerald-800 shadow",
    header: "bg-white/90 backdrop-blur border-b border-stone-200",
    card: "bg-white border border-stone-200 rounded-3xl shadow-sm hover:shadow-md",
    muted: "text-stone-500",
    btn: "bg-emerald-600 text-white font-bold rounded-2xl shadow-md shadow-emerald-600/20",
    btnGhost: "bg-white border border-stone-200 text-slate-800 rounded-2xl",
    badgeAdm: "bg-amber-600 text-white", badgePlate: "bg-emerald-50 border border-emerald-200 text-emerald-900",
    logo: "bg-emerald-600 text-white",
    tableHead: "bg-stone-100 text-stone-600", row: "border-stone-100",
    driverHero: "bg-[#064E3B] rounded-b-[2.5rem]",
    tile: "bg-white border border-stone-200 rounded-3xl shadow-sm",
    icon: (c) => ({ background: `${c}1A`, color: c, borderRadius: 18 }),
    pill: (c) => ({ background: `${c}18`, color: c }),
  },
  {
    id: "cyber",
    name: "غرفة التحكم الذكية",
    tagline: "أسود عميق بلمسات سماوية مضيئة — إحساس مراقبة لحظية وتقنية حديثة",
    fonts: { head: "Almarai", body: "Changa", url: "https://fonts.googleapis.com/css2?family=Almarai:wght@400;700;800&family=Changa:wght@400;500;600;700&display=swap" },
    swatch: ["#030712", "#111827", "#06B6D4", "#EC4899"],
    dark: true,
    page: "bg-[#030712] text-gray-100",
    sidebar: "bg-[#0B0F19] border-l border-gray-800",
    navItem: "text-gray-400 hover:bg-cyan-500/5 hover:text-cyan-300",
    navActive: "bg-cyan-500/10 text-cyan-300 border-r-2 border-cyan-400",
    header: "bg-[#0B0F19] border-b border-gray-800",
    card: "bg-gray-900 border border-cyan-500/15 rounded-xl hover:border-cyan-400/50",
    muted: "text-gray-400",
    btn: "bg-cyan-400 text-gray-950 font-black rounded-lg shadow-[0_0_20px_rgba(6,182,212,0.4)]",
    btnGhost: "bg-gray-900 border border-gray-700 text-gray-100 rounded-lg",
    badgeAdm: "bg-pink-500 text-white", badgePlate: "border border-cyan-400/60 text-cyan-300",
    logo: "bg-cyan-400 text-gray-950",
    tableHead: "bg-gray-800/60 text-cyan-200/80", row: "border-gray-800",
    driverHero: "bg-[#0B0F19] border-b border-cyan-500/30",
    tile: "bg-gray-900 border border-cyan-500/25 rounded-xl",
    icon: (c) => ({ background: "transparent", color: c, border: `1.5px solid ${c}`, boxShadow: `0 0 12px ${c}55, inset 0 0 10px ${c}22`, borderRadius: 12 }),
    pill: (c) => ({ border: `1px solid ${c}88`, color: c }),
  },
];
